import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../../ui/form/BaseFormView";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import UtilityForm from "../UtilityForm";
import UtilityFormBody from "../UtilityFormBody";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import Utility from "../../../../../model/utility/Utility";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {Utility} data updated utility object.
	 */
	onSubmit: (data: Utility) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Utility to edit
	 */
	editedUtility: Utility;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type IState = BaseFormViewState<UtilityForm>;

export default class EditUtilityFormView extends BaseFormView<UtilityForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: UtilityForm.fromUtility(props.editedUtility),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<UtilityFormBody form={this.state.form}
								 onFieldChange={this.onFieldChanged}
								 onFieldCompleted={this.onFieldCompleted}
								 onFocusChange={this.onFocusChange}
								 onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update Utility"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid((utility) => {
				// Preserve the original ID when updating
				const updatedUtility = new Utility(this.props.editedUtility.id, utility.name);
				this.props.onSubmit(updatedUtility);
			}, () => {});
		});
	}
}